// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import plenaryEntity from './entities/plenary.json';
import plenaryMenu from '../pages/plenary/menu.json';
import plenaryFullForm from '../pages/plenary/forms/full.json';
import plenaryContextForm from '../pages/plenary/forms/context.json';
import plenaryMiniForm from '../pages/plenary/forms/mini.json';
import plenaryLookupForm from '../pages/plenary/forms/lookup.json';
import plenaryTableView from '../pages/plenary/views/table.json';
import plenaryStagesView from '../pages/plenary/views/stages.json';
import plenaryCardsView from '../pages/plenary/views/cards.json';
import plenarySplitView from '../pages/plenary/views/split.json';
import plenaryCalendarView from '../pages/plenary/views/calendar.json';
import plenaryDashboardView from '../pages/plenary/views/dashboard.json';

/** Тип запису «Засідання» зі сторінками пакета: меню, форми та подання з pages/plenary/. */
export const plenaryDefinition: IRecordTypeDefinition = {
  ...plenaryEntity,
  views: assembleViewSet({
      table: plenaryTableView,
      stages: plenaryStagesView,
      cards: plenaryCardsView,
      split: plenarySplitView,
      calendar: plenaryCalendarView,
      dashboard: plenaryDashboardView,
  }),
  form: plenaryFullForm,
  forms: { full: plenaryFullForm, context: plenaryContextForm, mini: plenaryMiniForm, lookup: plenaryLookupForm },
  menu: plenaryMenu,
} as IRecordTypeDefinition;
